import React, { Component } from 'react';
import { TextImageSecond } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

/**
 * The BrotherCollaborationView section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class BrotherCollaborationView extends Component {

	render () {
		const {
			content,
			heading,
			subHeading,
			imageToRight,
		} = this.props.content.qrLandingPage.brotherCollaboration;

		return (
			<TextImageSecond
				{...{
					content,
					heading,
					imageToRight,
					subHeading,
				}}
				className='BrotherCollaborationView'
			/>
		);
	}

}

export default withLanguageContext(BrotherCollaborationView);



// WEBPACK FOOTER //
// ./src/components/views/BrotherCollaborationView/BrotherCollaborationView.js